import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { IMAGES } from "@/lib/constants";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 28 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
});

export default function Hero() {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative overflow-hidden grain pt-32 pb-20 md:pt-44 md:pb-28">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <div className="lg:col-span-7">
          <motion.span
            {...fade(0)}
            className="inline-flex items-center gap-2 text-xs font-outfit uppercase tracking-[0.25em] text-gold mb-6"
            data-testid="hero-eyebrow"
          >
            <Sparkles className="h-4 w-4" strokeWidth={1.5} />
            Przyroda · Geografia · Sztuczna inteligencja
          </motion.span>

          <motion.h1
            {...fade(0.1)}
            className="font-outfit font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink"
            data-testid="hero-title"
          >
            Złap Kod Natury
            <span className="block mt-3 text-forest font-normal">
              Odkryj nowoczesną stronę przyrody, geografii i&nbsp;AI
            </span>
          </motion.h1>

          <motion.p
            {...fade(0.2)}
            className="mt-7 max-w-xl font-manrope text-base md:text-lg text-ink-soft leading-relaxed"
            data-testid="hero-subtitle"
          >
            Łam schematy na lekcjach. Angażuj uczniów dzięki edukacyjnym escape roomom,
            zaszyfrowanym zagadkom przyrodniczym i&nbsp;mądremu wykorzystaniu sztucznej
            inteligencji w&nbsp;pracy nauczyciela.
          </motion.p>

          <motion.div {...fade(0.3)} className="mt-10 flex flex-wrap items-center gap-4">
            <button
              onClick={() => scrollTo("#materialy")}
              className="group inline-flex items-center gap-2 bg-forest text-beige px-8 py-4 rounded-2xl font-outfit tracking-wide hover:bg-forest-hover shadow-clay hover:shadow-clay-lg transition-all duration-300"
              data-testid="hero-cta-button"
            >
              Odbierz darmowe materiały
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
            </button>
            <button
              onClick={() => scrollTo("#kategorie")}
              className="inline-flex items-center gap-2 px-6 py-4 font-outfit text-ink border-b border-transparent hover:border-gold transition-colors duration-300"
              data-testid="hero-secondary-button"
            >
              Zobacz kategorie
            </button>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -inset-3 border border-gold/40 rounded-2xl translate-x-3 translate-y-3" aria-hidden />
          <img
            src={IMAGES.hero}
            alt="Las połączony z cyfrowym kodem natury"
            className="relative w-full h-[360px] md:h-[480px] object-cover rounded-2xl shadow-clay-lg"
            data-testid="hero-image"
          />
        </motion.div>
      </div>
    </section>
  );
}
